import { FC } from 'react';

import { TProductCategory } from '@lib/core/products/types';
import { currencies } from '@lib/tools/locale/utils/consts';
import { PRICE_RANGE } from '@lib/tools/shared/helpers/consts';

import { Flexbox } from '@components/web/src/foundations/Flexbox/Flexbox';
import { Text } from '@components/web/src/foundations/Text/Text';
import { TTypographyVariants } from '@components/web/src/foundations/Text/types';
import { COLORS } from '@components/web/src/styles';

interface IProps {
  originalPrice: number;
  currencySymbolValue: string;
  productCategory?: TProductCategory;
  customPriceRange?: { min: number; max?: number; level: number }[];
  textSize?: TTypographyVariants;
}

export const PriceRange: FC<IProps> = ({
  originalPrice,
  currencySymbolValue = currencies.EUR,
  productCategory,
  customPriceRange,
  textSize = 'subtitle1',
}) => {
  if (!originalPrice || originalPrice <= 0) return null;

  const ranges = customPriceRange || PRICE_RANGE[productCategory] || PRICE_RANGE.default;

  const activeLevel =
    ranges.find(({ min, max, isMax }) => originalPrice >= min && (isMax || (max !== undefined && originalPrice <= max)))
      ?.level ?? 0;

  return (
    <Flexbox align="center" gap={0} justify="flex-end">
      {Array.from({ length: 4 }, (_, index) => (
        <Text
          key={index}
          color={index < activeLevel ? COLORS.base.black : COLORS.gray[200]}
          size={textSize}
          text={currencySymbolValue}
          weight="semibold"
        />
      ))}
    </Flexbox>
  );
};
